// Hero and background images
export const HERO_IMAGE = "https://images.unsplash.com/photo-1705412238984-8bb35d443964?w=1920&q=80";
export const SERVICES_IMAGE = "https://images.pexels.com/photos/31413041/pexels-photo-31413041.jpeg?auto=compress&w=800";

// Logos for different themes
export const LOGO_DARK = "https://customer-assets.emergentagent.com/job_cloudgm-hub/artifacts/gl2mwiwe_CLOUDGM%20MARKET%20WHITE.png";
export const LOGO_LIGHT = "https://customer-assets.emergentagent.com/job_cloudgm-hub/artifacts/vu2e3mcb_CLOUDGM%20MARKET%20BLACK.png";

// Membership Card Images
export const BLUE_CARD_IMG = "https://customer-assets.emergentagent.com/job_cloudgm-hub/artifacts/4yi2ysjf_BLUE.png";
export const SILVER_CARD_IMG = "https://customer-assets.emergentagent.com/job_cloudgm-hub/artifacts/31ogz14y_SILVER.png";
export const GOLD_CARD_IMG = "https://customer-assets.emergentagent.com/job_cloudgm-hub/artifacts/llcce4yk_GOLD.png";
export const PLATINUM_CARD_IMG = "https://customer-assets.emergentagent.com/job_cloudgm-hub/artifacts/aq92mz6g_PLATINIAM.png";

